<template>
	<a
		class="flex justify-center items-center hover:text-dj-blue-dark active:text-dj-blue-dark transition-colors cursor-pointer"
		:class="{
			'text-dj-blue px-0': type == 'blue',
			'text-dj-grey-dark hover:text-dj-black px-0': type == 'grey',
			'text-dj-grey-light hover:text-dj-grey-dark px-0': type == 'lightgrey',
			'text-white hover:text-dj-grey-dark active:text-dj-grey-dark px-0': type == 'white',
			'bg-dj-blue text-white hover:bg-dj-blue-dark active:bg-dj-blue-dark px-5 py-3 rounded-normal':
				type == 'primary',
			'bg-dj-red text-white hover:bg-dj-red-dark active:bg-dj-red-dark px-5 py-3 rounded-normal':
				type == 'primary-red',
			'bg-dj-blue/5 text-dj-blue hover:bg-dj-blue/10 active:bg-dj-blue/10 px-5 py-3 rounded-normal':
				type == 'secondary',
			'bg-white text-dj-black border border-dj-grey-light hover:border-dj-grey active:bg-dj-gray/20 disabled:border-none px-5 py-3 rounded-normal':
				type == 'tertiary',
			'text-dj-grey-dark hover:text-dj-blue/80 px-4 py-2 w-full border-b-2 border-transparent hover:border-dj-blue/80':
				type == 'nav',
			'text-dj-blue hover:text-dj-blue/80 px-4 py-2 w-full border-b-2 border-dj-blue hover:border-dj-blue/80':
				type == 'nav-active',
			'text-dj-grey-dark hover:text-dj-red/80 px-4 py-2 w-full border-b-2 border-transparent hover:border-dj-red/80':
				type == 'nav-red',
			'text-dj-red hover:text-dj-red/80 px-4 py-2 w-full border-b-2 border-dj-red hover:border-dj-red/80':
				type == 'nav-active-red',
			'text-dj-gray hover:text-dj-grey active:text-dj-grey pointer-events-none cursor-none': disabled,
			loading: loading,
		}"
		v-bind="$attrs"
	>
		<slot></slot>
	</a>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "BaseLink",
	inheritAttrs: false,
	props: {
		type: {
			type: String,
			default: "blue",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
